module.exports = __webpack_public_path__ + "static/media/3.a21e227f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3.jpg
// module id = 504
// module chunks = 0